//src/mis/pages/Edit.js
import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { Button, Divider, Drawer, Grid, TextField, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import Stack from '@mui/material/Stack';
import { Description } from "@mui/icons-material";

import Modal from '@mui/material/Modal';
import { CloseRounded } from "@mui/icons-material";
import { fetchDepartmentsWithMachines } from "../data/machineList"; // Import the new function
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import env from "react-dotenv";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Edit = ({onSelected, open , onClose, onSuccess}) => {
  const [date, setDate] = useState(new Date());
  const navigate = useNavigate();
  const { rowIndex } = useParams();
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState({});
  const [ row , setRow] = useState();
  const [departments, setDepartments] = useState([]); // Store department list in state
  const [machines, setMachines] = useState({}); // Store machines mapping based on department

  const location = useLocation();
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );

  const [data, setData] = useState({
    id:"",
    AssignDate: null,
    Pending: "",
    WorkType: "",
    WorkSubType: "",   // <-- New field
    Comments: "",
    CompleteDate: null,
    CompleteDate: null,
    MainDesc: "",
    SlipNo: "",
    Remarks: "",
    AssignedTo : "",
    Department: "",   
    Machine:"",
  });

  const [sdate, setSDate] = useState(null);
  const [adate, setADate] = useState(null);
  const [cdate, setCDate] = useState(null);

  const workSubTypeOptions = {
    "New Work": [""],
    "Electrical Maintenance": ["Breakdown", "Preventive", "Mould Breakdown"],
    "Machine Maintenance": ["Mould Change", "Breakdown", "Preventive", "Mould Breakdown"],
  };  

  useEffect(() => {
    const fetchDepartmentsAndMachines = async () => {
      const departmentMachineMapping = await fetchDepartmentsWithMachines();
      setDepartments(Object.keys(departmentMachineMapping)); // Set department names
      setMachines(departmentMachineMapping); // Set the entire mapping
    };
    fetchDepartmentsAndMachines();
  }, []);

  const getDataFromDb = async () => {
    //  console.log("here"+onSelected)
    try {
      if (onSelected) {
        const { id, field, dataId} = onSelected;
        const rIndex = dataId;
        // console.log("dataId"+dataId)
        setRow(dataId);      
          try { 
              const res = await fetch(
              `${process.env.REACT_APP_MISBACKEND_URL}/maintenance/${rIndex}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const response = await res.json();
        setData(response[0]); // Assuming response is an array with one object

        // Set the selected department and reset machines
        const selectedDepartment = response[0].Department;
        const machinesForDepartment = machines[selectedDepartment] || [];
        setData((prevData) => ({
          ...prevData,
          Department: selectedDepartment,
          Machine: response[0].Machine || machinesForDepartment[0] || "", // Set the correct machine
        }));
      } catch (error) {
        console.log(error);
      }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataFromDb(data);   
  }, [onSelected]);
  
  const handleClose = () => {
   onSuccess();
 
  }

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setData((prevData) => ({ ...prevData, [name]: value }));

  //   if (name === 'Department') {
  //     const machinesForDepartment = machines[value] || [];
  //     setData((prevData) => ({ ...prevData, Machine: machinesForDepartment[0] || "" })); // Reset machine selection
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
      ...(name === "WorkType" ? { WorkSubType: "" } : {}) // Reset on change
    }));

    if (name === 'Department') {
      const machinesForDepartment = machines[value] || [];
      setData((prevData) => ({ ...prevData, Machine: machinesForDepartment[0] || "" })); // Reset machine selection
    }
  };
  
  const validateForm = (data) => {
    const errors = {};
    if (data.WorkType.trim() === 'Machine Maintenance' && !data.Machine.trim()) {
        errors.Machine = 'Machine is required if worktype is machine maintenance';
        console.log(errors.Machine);
    }

    return errors;
  };

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const modalStyle1 = {
    maxWidth: 1000,marginLeft:"150px", marginTop:"50px",
    
      // overflow:'scroll',
    };

    const handleSubmitOnDB = async (e) => {
      e.preventDefault();
  
      const newErrors = validateForm(data);
      setErrors(newErrors);
      if(adate !== null){
        data['AssignDate'] = moment(new Date(adate)).format("YYYY-MM-DD").toString()
      }
      if(sdate !== null){
        data['StartDate'] = moment(new Date(sdate)).format("yyyy-MM-DD hh:mm A").toString()
      }
      if(cdate !== null){
        data['CompleteDate'] = moment(new Date(cdate)).format("yyyy-MM-DD hh:mm A").toString()
      }

      if (Object.keys(newErrors).length === 0) {
        try{
          const res = await fetch(
            `${process.env.REACT_APP_MISBACKEND_URL}/updateMaintenance`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );
          onClose();
          onSuccess();
        } catch (error) {
          console.log(error);
        }
      }else {
        console.log(`Form submission failed
        due to validation errors.`);
    } 
    };

  return  (open) ?(
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 730,
          padding: 2,
        }
      }}
    >
    <div style={{ width: "100%",}}  >
     
      <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
            marginBottom:"5px",p: 2,borderRadius: 1}} onSubmit={handleSubmitOnDB}>
       
        <Typography variant="h4" align="center" color="#4863A0" gutterBottom>
            Update Maintenance Record
        </Typography>
        <Divider style={{ marginBottom: '20px' }} />    
        <Box className="outerbox"  sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
        <Item>
          <FormControl size="medium" fullWidth>
            <label htmlFor="AssignDate" className="form-label">Assign Date*</label>
            
            <DatePicker
            value={data.AssignDate} 
            disabled
            disabledKeyboardNavigation
            required
            name="AssignDate"
            selected={adate}          
            className="customInput"
            popperProps={{
              positionFixed: true // use this to make the popper position: fixed
            }}
            dateFormat="yyyy-MM-dd"
            autoComplete="off"        
            onChange={(adate) => setADate(moment(new Date(adate)))}
          />
          </FormControl>
          </Item>
          <Item>
            <FormControl>
              <label htmlFor="StartDate" className="form-label">Start Date</label>
              <DatePicker
              showTimeSelect
              disabledKeyboardNavigation
              name="StartDate"              
              className="customInput"
              selected={sdate ? new Date(Date.parse(sdate)) : data.StartDate ? new Date(Date.parse(data.StartDate)) : null}
              popperProps={{
                positionFixed: true // use this to make the popper position: fixed
              }}
              dateFormat="yyyy-MM-dd hh:mm aa"
              autoComplete="off" 
              onChange={sdate => setSDate(sdate)}
              /> 
            
              <label htmlFor="CompleteDate" className="form-label">Complete Date</label>
              
              <DatePicker
              showTimeSelect
              disabledKeyboardNavigation
              name="CompleteDate"
              selected={cdate ? new Date(Date.parse(cdate)) : data.CompleteDate ? new Date(Date.parse(data.CompleteDate)) : null}             
              className="customInput"
              popperProps={{
                positionFixed: true // use this to make the popper position: fixed
              }}
              dateFormat="yyyy-MM-dd hh:mm aa"
              autoComplete="off"  
              onChange={(cdate) => setCDate(new Date(cdate))}
              /> 
          </FormControl>
        </Item>
        </Box>
        <Box className="outerbox"  sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
        <Item>
          <FormControl fullWidth>
            <label htmlFor="WorkType" className="form-label">Work Type*</label>
            <Select
              name="WorkType"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={data.WorkType}
              onChange={handleChange}
              size="small"
              autoWidth
              required
              displayEmpty
            >
              <MenuItem value=""><em>Select Work Type</em></MenuItem>
              <MenuItem value="New Work">New Work</MenuItem>
              <MenuItem value="Electrical Maintenance">Electrical Maintenance</MenuItem>
              <MenuItem value="Machine Maintenance">Machine Maintenance</MenuItem>
          </Select> 

          {data.WorkType && workSubTypeOptions[data.WorkType] && (
            <FormControl fullWidth>
              <label htmlFor="WorkSubType" className="form-label">Work Sub Type</label>
              <Select
                name="WorkSubType"
                value={data.WorkSubType}
                onChange={handleChange}
                size="small"
                displayEmpty
                disabled={data.WorkType === "New Work"}  // Disable if "New Work"
              >
                <MenuItem value=""><em>Select Work Sub Type</em></MenuItem>
                {workSubTypeOptions[data.WorkType].map((subType, index) => (
                  <MenuItem key={index} value={subType}>{subType}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}  

          <label htmlFor="Department" className="form-label">Department*</label>
          <Select
                  name="Department"
                  value={data.Department}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value=""><em>Select department</em></MenuItem>
                  {departments.map((department, index) => (
                    <MenuItem key={index} value={department}>{department}</MenuItem>
                  ))}
                </Select>
                <label htmlFor="Machine" className="form-label">Machine*</label>
                <Select
                  name="Machine"
                  value={data.Machine}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value=""><em>Select machine</em></MenuItem>
                  {(machines[data.Department] || []).map((machine, index) => (
                    <MenuItem key={index} value={machine}>{machine}</MenuItem>
                  ))}
                </Select>
            {errors.Machine &&
                          <span style={{ color: 'red'}} className="error-message">
                              {errors.Machine}
                          </span>
            }
            </FormControl>  
        </Item>
        <Item>    
            <label htmlFor="Description" className="form-label">
              Description 
            </label>
            <textarea
              name="MainDesc"
              cols="30"
              rows="2"
              className="form-control"              
              style={{borderColor: colors.grey[700],border: '1px solid'
                }}
              value={data.MainDesc}
              onChange={handleChange}
            />  
           <label htmlFor="Comments" className="form-label">
            Comments 
          </label>
          <textarea
            name="Comments"
            cols="30"
            rows="3"
            className="form-control"
            value={data.Comments}
            style={{borderColor: colors.grey[700],border: '1px solid'
                }}
            onChange={handleChange}
          />
        </Item>
      </Box>
     
      <Box sx={{ display: 'flex',  justifyContent: 'center', padding:'3px'}}>
          <Stack spacing={2} direction="row">  
          <label htmlFor="SlipNo" className="form-label">Slip No*</label>
          <TextField size="small" disabled required fullWidth value={data.SlipNo}  name="SlipNo" onChange={handleChange} variant="outlined" />
          <Divider/><Divider/><Divider/> 
          <label htmlFor="Remarks" className="form-label">Remarks</label>
          <TextField size="small" fullWidth value={data.Remarks}  name="Remarks" onChange={handleChange} variant="outlined" />
          <Divider/><Divider/><Divider/> 
          <label htmlFor="AssignedTo" className="form-label">Assigned To*</label>
          <TextField size="small" required fullWidth value={data.AssignedTo}  name="AssignedTo" onChange={handleChange} variant="outlined" />
          <Divider/><Divider/><Divider/> 
       </Stack>        
      </Box>
      <Divider style={{ marginTop: '20px' }} />    
            <Grid item xs={12} sx={{ marginTop:"20px", display: 'flex', justifyContent: 'center' }}>
              <Button size="large" onClick={() => [onClose(), handleClose()]} color="secondary" sx={{ marginRight: 2,':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    }, }}>
                Cancel
              </Button>
              <Button size="large" onClick={handleSubmitOnDB}  sx={{backgroundColor:'#4863A0',':hover': {
                      bgcolor: '#4863C0', // theme.palette.primary.main
                      color: 'white',
                    },}} variant="contained">
                Save
              </Button>            
            </Grid>
    </form>
    </div>
    </Drawer>
  ): ""
  
};

export default Edit;